import React, { FC } from "react";
import { ImageDetail } from "../ImageDetail";
import { ProductImage } from "../../../../ProductImage";
import { Divider } from "../../../../Divider";
import { Customization } from "../../../../../types/graphql/generated";
import { StyledDetails, StyledHex, StyledImageWrapper } from "./index.styled";

interface MainDetailsProps {
  customization: Customization;
  isNested?: boolean;
}

/**
 * Gatorade ID Bottles or Towels
 */
export const MainDetails: FC<MainDetailsProps> = ({
  customization,
  isNested,
}) => {
  const type = customization.__typename;

  if (type === "GatoradeIdBottle") {
    const {
      bottleLidThumbnailImage,
      bottleSideFeatureText,
      bottleSideFeatureType,
      bottleSideLogoUrl,
      bottleSideMascotName,
      bottleSidePattern,
      bottleSidePatternImage,
      bottleSidePrimaryColor,
      bottleSidePrimaryColorValue,
      bottleSideSecondaryColor,
      bottleSideSecondaryColorValue,
      bottleSideThumbnailImage,
    } = customization;
    return (
      <>
        <StyledImageWrapper>
          {bottleSideThumbnailImage && (
            <ProductImage
              src={bottleSideThumbnailImage}
              alt="customization"
              size={60}
            />
          )}
          {bottleLidThumbnailImage && (
            <ProductImage
              src={bottleLidThumbnailImage}
              alt="customization"
              size={60}
            />
          )}
        </StyledImageWrapper>

        <StyledDetails>
          {bottleSidePrimaryColor && <div>{bottleSidePrimaryColor}</div>}
          {bottleSidePrimaryColorValue && (
            <StyledHex hex={bottleSidePrimaryColorValue} />
          )}
        </StyledDetails>

        {bottleSidePrimaryColor !== bottleSideSecondaryColor && (
          <StyledDetails>
            {bottleSideSecondaryColor && <div>{bottleSideSecondaryColor}</div>}
            {bottleSideSecondaryColorValue && (
              <StyledHex hex={bottleSideSecondaryColorValue} />
            )}
          </StyledDetails>
        )}

        <StyledDetails>
          {bottleSidePattern && <div>{bottleSidePattern}</div>}
          {bottleSidePatternImage && (
            <ImageDetail round value={bottleSidePatternImage} />
          )}
        </StyledDetails>

        <StyledDetails>
          {bottleSideFeatureType === "text" &&
            bottleSideFeatureText &&
            `Bottle back: ${bottleSideFeatureText}`}
          {bottleSideFeatureType === "logo" && (
            <>
              {"Bottle back: Uploaded logo"}
              {bottleSideLogoUrl && (
                <>
                  {" "}
                  <ImageDetail round value={bottleSideLogoUrl} />
                </>
              )}
            </>
          )}
          {bottleSideFeatureType === "mascot" && (
            <>
              {"Bottle back: Mascot"}
              {bottleSideMascotName && (
                <span>{` • ${bottleSideMascotName}`}</span>
              )}
            </>
          )}
        </StyledDetails>

        <Divider />
      </>
    );
  }

  if (type === "GatoradeTowel") {
    const {
      towelFeatureText,
      towelFeatureType,
      towelLogoUrl,
      towelMascotName,
      towelPattern,
      towelPatternImage,
      towelPrimaryColor,
      towelPrimaryColorValue,
      towelSecondaryColor,
      towelSecondaryColorValue,
      towelThumbnailImage,
    } = customization;
    return (
      <>
        {/* show this if nested inside a bundle */}
        {isNested && towelThumbnailImage && (
          <StyledImageWrapper>
            <ProductImage
              src={towelThumbnailImage}
              alt="customization"
              size={60}
            />
          </StyledImageWrapper>
        )}

        <StyledDetails>
          {towelPrimaryColor && <div>{towelPrimaryColor}</div>}
          {towelPrimaryColorValue && <StyledHex hex={towelPrimaryColorValue} />}
        </StyledDetails>

        {towelPrimaryColor !== towelSecondaryColor && (
          <StyledDetails>
            {towelSecondaryColor && <div>{towelSecondaryColor}</div>}
            {towelSecondaryColorValue && (
              <StyledHex hex={towelSecondaryColorValue} />
            )}
          </StyledDetails>
        )}

        <StyledDetails>
          {towelPattern && <div>{towelPattern}</div>}
          {towelPatternImage && <ImageDetail round value={towelPatternImage} />}
        </StyledDetails>

        <StyledDetails>
          {towelFeatureType === "text" &&
            towelFeatureText &&
            `Design text: ${towelFeatureText}`}
          {towelFeatureType === "logo" && (
            <>
              {"Towel: Uploaded logo"}
              {towelLogoUrl && (
                <>
                  {" "}
                  <ImageDetail round value={towelLogoUrl} />
                </>
              )}
            </>
          )}
          {towelFeatureType === "mascot" && (
            <>
              {"Towel: Mascot"}
              {towelMascotName && <span>{` • ${towelMascotName}`}</span>}
            </>
          )}
        </StyledDetails>
      </>
    );
  }

  return null;
};
